// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 转换es6代码兼容ie
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5';

// 仓库
import store from './store'

// 公共的样式
import './style/common.css'
import './style/detail.css'
import './assets/fonts/iconfont.css'
// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '../src/utils/el-dialog'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$md5 = md5;


import jweixinModule from "jweixin-module"
Vue.prototype.$jweixinModule = jweixinModule;
import * as wechat from './common/wechat';
Vue.prototype.$wechat = wechat;

Vue.config.ignoredElements = [
    'wx-open-launch-app',
    'wx-open-launch-weapp'
]

import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'
Vue.use(vuescroll)  

Vue.prototype.$bus = new Vue();

Vue.directive('debounce', {
    inserted(el, binding, vnode) {
        let timer = {}
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                binding.value()
            }, 2000)
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})

var routeList = [];
router.beforeEach((to, from, next) => {
    var index = -1;
    for (var i = 0; i < routeList.length; i++) {
        if (routeList[i].name == to.name) {
            index = i;
            break;
        }
    }
    if (index !== -1) {
        //如果存在路由列表，则把之后的路由都删掉
        routeList.splice(index + 1, routeList.length - index - 1);
    } else if (to.name != '登录') {
        routeList.push({ "name": to.name, "path": to.fullPath });
    }
    to.meta.routeList = routeList;
    next()
});



// WEBPACK FOOTER //
// ./src/main.js